import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const LogoZipUpKnit = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.tops.LogoZipUpKnit.itemName}
      name={AW23.tops.LogoZipUpKnit.itemName}
      price={AW23.tops.LogoZipUpKnit.itemPrice}
      fabric={AW23.tops.LogoZipUpKnit.itemFabric}
      src={AW23.tops.LogoZipUpKnit.sizeChart}
      divId={AW23.tops.LogoZipUpKnit.shopifyDivId}
      mainId={AW23.tops.LogoZipUpKnit.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.tops.LogoZipUpKnit.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.tops.LogoZipUpKnit.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default LogoZipUpKnit;
